import { resolvePrivacy } from '@neuronic/privacy';

/**
 * Create the tag frame's single live privacy controller. The vendor ID is
 * public build-time configuration and remains unset until GVL registration.
 */
export function resolveTagPrivacy() {
  const options = Number.isInteger(__TCF_VENDOR_ID__) && __TCF_VENDOR_ID__ > 0
    ? { tcfVendorId: __TCF_VENDOR_ID__ }
    : {};

  return resolvePrivacy(options);
}

/** Safe debug shape: never include raw TC or GPP strings. */
export function summarizePrivacy(snapshot) {
  return {
    capabilities: snapshot.capabilities,
    reasons: snapshot.reasons,
    signals: {
      tcf: {
        status: snapshot.signals.tcf.status,
        gdprApplies: snapshot.signals.tcf.gdprApplies,
        tcStringPresent: Boolean(snapshot.signals.tcf.tcString),
      },
      gpp: {
        status: snapshot.signals.gpp.status,
        applicableSections: snapshot.signals.gpp.applicableSections,
        gppStringPresent: Boolean(snapshot.signals.gpp.gppString),
      },
      gpc: snapshot.signals.gpc,
      dnt: snapshot.signals.dnt,
      lmt: snapshot.signals.lmt,
    },
  };
}
